// extracted by mini-css-extract-plugin
export default {"linksContainer":"AccountOptions_linksContainer__sxIbn","deleteAccount":"AccountOptions_deleteAccount__Qjhnk"};